import OutdatedAlbumFolder from './OutdatedAlbumFolder';
import withModal from '../modal/withModal';

export const OUTDATED_ALBUM_FOLDER_MODAL = 'modal/OUTDATED_ALBUM_FOLDER';

export default withModal(OutdatedAlbumFolder, {
  name: OUTDATED_ALBUM_FOLDER_MODAL,
  hideHeader: true,
  shouldCloseOnOverlayClick: false,
  size: 'sm',
  type: 'full',
});
